import React from 'react';
import { useDesignV2 } from '../../utils/designV2';
import blueCheckImg from '../../assets/blue_check.svg';

// The "supported by" verified check. Classic keeps the cyan image; design v2
// draws it inline in the accent token (amber disc, page-colour tick) so it
// follows the theme like every other mark.
const SupportedCheck = ({ className = 'supported-check' }) => {
    const v2 = useDesignV2();
    if (!v2) return <img className={className} src={blueCheckImg} alt="" />;
    return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" style={{ color: 'var(--color-accent)' }}>
            <circle cx="12" cy="12" r="12" fill="currentColor" />
            <path d="M6.2 12.4 L9.8 16 L17.8 8" fill="none" stroke="var(--v2-on-accent)" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default SupportedCheck;
